var map = {
	"./arrow-beige.png": 25,
	"./arrow.png": 26,
	"./background.jpg": 27,
	"./flags/be.svg": 28,
	"./flags/cn.svg": 29,
	"./flags/de.svg": 30,
	"./flags/es.svg": 31,
	"./flags/fr.svg": 32,
	"./flags/gb.svg": 33,
	"./flags/it.svg": 34,
	"./flags/jp.svg": 35,
	"./flags/us.svg": 36,
	"./icons/arrow-light.svg": 37,
	"./icons/arrow.svg": 38,
	"./icons/back.svg": 39,
	"./icons/clock.svg": 40,
	"./icons/close.svg": 41,
	"./icons/error.svg": 42,
	"./icons/facebook.svg": 43,
	"./icons/info.svg": 44,
	"./icons/instagram.svg": 45,
	"./icons/linkedin.svg": 46,
	"./icons/logo-secondary.svg": 47,
	"./icons/mail.svg": 48,
	"./icons/marker.svg": 49,
	"./icons/phone.svg": 50,
	"./icons/picto.svg": 51,
	"./icons/pin.svg": 52,
	"./icons/pinterest.svg": 53,
	"./icons/slider-arrow.svg": 54,
	"./icons/success.svg": 55,
	"./icons/twitter.svg": 56,
	"./icons/weibo.svg": 57,
	"./icons/youtube.svg": 58,
	"./logo-small.png": 59,
	"./logo-small.svg": 60,
	"./logo.png": 61,
	"./logo.svg": 62
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24;